import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { fetchList, printOrderDelivery, getOrderSku, orderDictList,orderReceived} from '@/api/sms/shopify-order';
import {getAllAdminList, getAllDepotList} from '@/api/sms/arrival-order';
import moment from 'moment';
import getLodop from '@/utils/lodop';
import { Message } from 'element-ui';

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		multipleSelection: [],
		goodsList: [],
		drawerVisible: false,
		depotList: [],
		orderDictList: [],
		operatorList: []
	},
	actions: {
		async getList({ state, dispatch }, payload) {
			await wait(dispatch, 'sms.forwarding-order.list', async function () {
				const { searchForm } = state;
				await dispatch('getData', {
					caller: fetchList,
					options: {
						depotId: searchForm.depotId,
						orderSn: searchForm.orderSn,
						shopifyOrderIds: searchForm.shopifyOrderIds,
						invoiceId: searchForm.invoiceId,
						buyerEmail: searchForm.buyerEmail,
						trackingNos: searchForm.trackingNos,
						startDate: searchForm.time && moment(moment(searchForm.time[0]).format('YYYY-MM-DD')).valueOf() / 1000,
						endDate: searchForm.time && moment(moment(searchForm.time[1]).format('YYYY-MM-DD')).valueOf() / 1000,
						shippingStartDate: searchForm.shippingTime && moment(moment(searchForm.shippingTime[0]).format('YYYY-MM-DD')).valueOf() / 1000,
						shippingEndDate: searchForm.shippingTime && moment(moment(searchForm.shippingTime[1]).format('YYYY-MM-DD')).valueOf() / 1000,
						status: searchForm.status,
						...payload
					}
				});
			})
		},
		async getOrderSku({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'sms.forwarding-order.sku', async function () {
				const response = await getOrderSku(payload);
				if (response.data && response.data.length > 0) {
					commit('save', {
						goodsList: response.data
					})
				} else {
					Message.error({
						message: '无此订单',
						onClose: () => {
							commit('closeDrawer')
						}
					})
				}
			})
		},
		async printOrderDelivery({ state, dispatch }, payload) {

			const { ids, batch } = payload;

			await wait(dispatch, `sms.forwarding-order.print.${payload.batch ? 'batch' : ids[0]}`, async function () {
				const response = await printOrderDelivery({
					ids: ids.join(',')
				});
				const LODOP = getLodop();
				LODOP.PRINT_INIT("createOrder");
				LODOP.SET_PRINT_STYLEA(0, "HtmWaitMilSecs", 100);
				response.data.map((v) => {
					LODOP.ADD_PRINT_HTM("10%", "10%", "90%", "80%", v);
					LODOP.NewPageA();
				})
				LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Height");
				LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Width");
				// LODOP.PREVIEW();
				// 直接打印
				LODOP.PRINT();
			})
		},
		async getAllDepotList({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'sms.forwarding-order.all-depot', async function() {
				const response = await getAllDepotList();
				if (response.data) {
					commit('save', {
						depotList: response.data.list
					})
				}
            })
		},
		async getOrderDictList({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'sms.forwarding-order.order-dict-list', async function() {
				const response = await orderDictList();
				if (response.data) {
					commit('save', {
						orderDictList: response.data.shippingStatusOption
					})
				}
            })
		},
		async getOperatorList({ state, dispatch, commit }, payload){
			await wait(dispatch, 'sms.th-forwarding-order.dict-list', async function() {
				const response = await getAllAdminList();
				if (response.data) {
					commit('save', {
						operatorList: response.data.adminList
					})
				}
			})
		},
	},
	mutations: {
		openDrawer(state) {
			Object.assign(state, { drawerVisible: true })
		},
		closeDrawer(state) {
			Object.assign(state, { drawerVisible: false })
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/shopify-order/list.js